/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_DescriptionInputs */

const en_media_import_description = /** @type {(inputs: Media_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import media from various sources and configure media settings`)
};

const fr_media_import_description = /** @type {(inputs: Media_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer des medias depuis diverses sources et configurer les parametres du media`)
};

const de_media_import_description = /** @type {(inputs: Media_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importieren Sie Medien aus verschiedenen Quellen und konfigurieren Sie die Medieneinstellungen.`)
};

const it_media_import_description = /** @type {(inputs: Media_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa contenuti multimediali da varie fonti e configura le impostazioni multimediali`)
};

const ru_media_import_description = /** @type {(inputs: Media_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортируйте медиафайлы из различных источников и настраивайте параметры воспроизведения.`)
};

const es_media_import_description = /** @type {(inputs: Media_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar medios desde varias fuentes y configurar ajustes de medios`)
};

const zh_cn2_media_import_description = /** @type {(inputs: Media_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从各种来源导入媒体并配置媒体设置`)
};

const ja_media_import_description = /** @type {(inputs: Media_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さまざまなソースからメディアをインポートし、メディア設定を構成する`)
};

const hi_media_import_description = /** @type {(inputs: Media_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विभिन्न स्रोतों से मीडिया आयात करें और मीडिया सेटिंग्स कॉन्फ़िगर करें`)
};

const pt_pt2_media_import_description = /** @type {(inputs: Media_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe conteúdo de diversas fontes e configure as definições de mídia.`)
};

/**
* | output |
* | --- |
* | "Import media from various sources and configure media settings" |
*
* @param {Media_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_description = /** @type {((inputs?: Media_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_description(inputs)
	if (locale === "de") return de_media_import_description(inputs)
	if (locale === "it") return it_media_import_description(inputs)
	if (locale === "ru") return ru_media_import_description(inputs)
	if (locale === "es") return es_media_import_description(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_description(inputs)
	if (locale === "ja") return ja_media_import_description(inputs)
	if (locale === "hi") return hi_media_import_description(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_description(inputs)
	return en_media_import_description(inputs)
});